import { IndicatorScoreModel } from './indicator-score-model';

export interface QuadrantModel {
  quadrant: number;
  heading: string;
  subHeading: string;
  index: number;
  score: number;
  indicators: IndicatorScoreModel[];
}
